import {SELECT_TYPE} from './FileTypeResource';

export const imageFileTypeResource = [
    {
        name: SELECT_TYPE, value: SELECT_TYPE
    },
    {
        name: 'apng', value: 'apng'
    },
    {
        name: 'avif', value: 'avif'
    },
    {
        name: 'bmp', value: 'bmp'
    },
    {
        name: 'gif', value: 'gif'
    },
    {
        name: 'vnd.microsoft.icon', value: 'vnd.microsoft.icon'
    },
    {
        name: 'ico', value: 'ico'
    },
    {
        name: 'jpeg', value: 'jpeg'
    },
    {
        name: 'jpg', value: 'jpg'
    },
    {
        name: 'png', value: 'png'
    },
    {
        name: 'svg', value: 'svg'
    },
    {
        name: 'svg+xml', value: 'svg+xml'
    },
    {
        name: 'tif', value: 'tif'
    },
    {
        name: 'tiff', value: 'tiff'
    },
    {
        name: 'webp', value: 'webp'
    }
];